import { Box } from '@mui/material'
import React from 'react'

const Screen = () => {
    return (
        <Box></Box>
    )
}

export default Screen